import React from "react";
import { BrowserRouter as Router, Route, Routes, NavLink } from "react-router-dom";
import useGoogleAnalytics from "./hooks/useGoogleAnalytics";
import Dashboard from "./pages/Dashboard";
import Header from "./components/Header";
import Charts from "./pages/Charts";
import About from "./pages/About";
import AttackSummary from "./components/AttackSummary";
import "./App.css";

function App() {
    return (
        <Router>
            <GoogleAnalyticsWrapper />
            <div>
                <Header />
                <AttackSummary />

                {/* Navigation Tabs */}
                <nav className="navbar">
                    <NavLink to="/" className="nav-link">
                        Attacks
                    </NavLink>
                    <NavLink to="/charts" className="nav-link">
                        Charts
                    </NavLink>
                    <NavLink to="/about" className="nav-link">
                        About
                    </NavLink>
                </nav>

                <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/charts" element={<Charts />} />
                    <Route path="/about" element={<About />} />
                </Routes>
            </div>
        </Router>
    );
}

const GoogleAnalyticsWrapper = () => {
    useGoogleAnalytics("G-KRZNMQ9MBE");
    return null; // No UI needed, just tracking
};

export default App;